// extracted by mini-css-extract-plugin
export default {"header":"viewAll_header__FFNTC","title":"viewAll_title__LdwiM"};